import { Layouts } from '~/shared';

export interface LayoutProps {
	displayName: Layouts | null;
	isHud: boolean;
	hudVisible: boolean;
	transitionTime: number;
}

export class LayoutBuilder {
	private props: LayoutProps = {
		displayName: null,
		isHud: false,
		hudVisible: false,
		transitionTime: 0,
	};

	constructor(private LayoutComponent: () => JSX.Element) {}

	public build(): () => JSX.Element {
		Object.assign(this.LayoutComponent, this.props);
		return this.LayoutComponent;
	}

	public setDisplayName(displayName: Layouts) {
		this.props.displayName = displayName;
		return this;
	}

	public setIsHud(isHud: boolean) {
		this.props.isHud = isHud;
		return this;
	}

	public setHudVisible(isVisible: boolean) {
		this.props.hudVisible = isVisible;
		return this;
	}

	public setTransitionTime(transitionTime: number) {
		this.props.transitionTime = transitionTime;
		return this;
	}
}
